import { render } from "./CommonFooter.vue?vue&type=template&id=7949dbe0&scoped=true"
import script from "./CommonFooter.vue?vue&type=script&lang=js"
export * from "./CommonFooter.vue?vue&type=script&lang=js"

import "./CommonFooter.vue?vue&type=style&index=0&id=7949dbe0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7949dbe0"]])

export default __exports__